import { render, staticRenderFns } from "./bindPhoneBase.vue?vue&type=template&id=1f80fff4&scoped=true&"
import script from "./bindPhoneBase.vue?vue&type=script&lang=js&"
export * from "./bindPhoneBase.vue?vue&type=script&lang=js&"
import style0 from "./bindPhoneBase.vue?vue&type=style&index=0&id=1f80fff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80fff4",
  null
  
)

export default component.exports